export default __webpack_public_path__ + "static/media/E3DC_Logo_438px_sRGB_grey.8dcef431.png";